import React from "react"
import _ from "lodash"

import DateField from "components/table/display/date"

const UnitStartDisplay = (props: {rowData: {}, field: string}) => {
  const unitStart = _.get(props.rowData, props.field)

  let display
  if(!unitStart) {
    display = "None"
  } else if(unitStart.state === "analysisStart") {
    display = "Analysis Start"
  } else if(unitStart.state === "none") {
    display = "None"
  } else if(unitStart.state === "specifiedDate") {
    display = <DateField rowData={unitStart} field="date" allowRelative withoutDays/>
  } else {
    display = "None"
  }

  return (
    <span>{display}</span>
  )
}

export default UnitStartDisplay
